import type { BillingPlan, CustomBillingPlan } from '@core/billing-types';

import { getActiveProductOrThrow } from './get-active-product-or-throw';
import type { PricingFeatureLoadedModel } from '../types/pricing-feature.types';

export const getAssignedProduct = (
  model: PricingFeatureLoadedModel,
  billingPlans: BillingPlan[] | undefined,
  activeBillingPlan: BillingPlan | undefined,
  activeProduct = getActiveProductOrThrow(model, billingPlans, activeBillingPlan),
): CustomBillingPlan | undefined => {
  const assignedProduct = (billingPlans || [])
    .filter(p => filterFn(p, model))
    .sort((a, b) => (a.createdAt > b.createdAt ? -1 : 1))
    .shift();

  return activeProduct?.id !== assignedProduct?.id ? <CustomBillingPlan>assignedProduct : undefined;
};

const filterFn = (p: BillingPlan, model: PricingFeatureLoadedModel) => {
  const isAssignedProduct = p.custom;

  if (isAssignedProduct) {
    return model.currencyLock ? p.currency === model.currency : true;
  }

  return false;
};
